<template>
  <div class="loading-overlay-container">
    <!-- Opaque background -->
    <div class="loading-overlay-modal-background" />

    <!-- Inner body -->
    <div class="loading-inner-container">
      <h2 style="text-align: center;">
        Review Payment
      </h2>

      <div v-if="forPartialPayment === true" class="total-container">
        <br>
        <div class="selected-tax">
          <label>Item Subtotal</label>
          <label>${{
            invoice
              ? (
                invoice.invoice_buyers_total +
                invoice.invoice_hammer_total
              ).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })
              : 0
          }}</label>
        </div>
        <div v-if="useArta && selectedPickUp == false" class="selected-tax">
          <label>Shipping Subtotal</label>
          <label v-if="selectedShippingOption != null">{{
            selectedShippingOption.display_total_charges.toLocaleString(
              undefined,
              { minimumFractionDigits: 2, maximumFractionDigits: 2 }
            )
          }}</label>
          <label v-else>$0.00</label>
        </div>
        <div class="selected-tax">
          <label>Tax</label>
          <label>${{
            invoice
              ? invoice.invoice_tax_total.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })
              : 0
          }}</label>
        </div>
        <div v-if="convenienceFee !== '' && convenienceFee !== '0' && convenienceFee !== undefined"
          class="selected-tax">
          <label>*Convenience Fee 3%</label>
          <label>${{
            convenienceFee.toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })
          }}</label>
        </div>
        <!-- Final total section -->
        <div class="final-total-container">
          <h2>Please Pay</h2>
          <h2>
            ${{
              partialPaymentAmount.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })
            }}
          </h2>
        </div>
      </div>

      <div v-if="forPartialPayment === false" class="total-container">
        <br>

        <div class="selected-tax">
          <label>Item Subtotal</label>
          <label>${{
            invoice
              ? (
                invoice.invoice_buyers_total +
                invoice.invoice_hammer_total
              ).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })
              : 0
          }}</label>
        </div>

        <div v-if="useArta && selectedPickUp == false" class="selected-tax">
          <label>Shipping Subtotal</label>
          <label v-if="selectedShippingOption != null">{{
            selectedShippingOption.display_total_charges.toLocaleString(
              undefined,
              { minimumFractionDigits: 2, maximumFractionDigits: 2 }
            )
          }}</label>
          <label v-else>$0.00</label>
        </div>

        <div class="selected-tax">
          <label>Tax</label>
          <label>${{
            invoice
              ? invoice.invoice_tax_total.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })
              : 0
          }}</label>
        </div>

        <div v-if="convenienceFee !== '' && convenienceFee !== '0' && convenienceFee !== undefined"
          class="selected-tax">
          <label>*Convenience Fee 3%</label>
          <label>${{
            convenienceFee.toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })
          }}</label>
        </div>

        <!-- Final total section -->
        <div class="final-total-container">
          <h2 v-if="invoice && invoice.payment_status == 'overpaid'">
            Credit Owed
          </h2>
          <h2 v-else-if="invoice && invoice.payment_status == 'unpaid'">
            Please Pay
          </h2>
          <h2 v-else>
            Balance
          </h2>
          <h2 :class="invoice && invoice.payment_status == 'overpaid' ? 'overpaid' : ''
            ">
            ${{
              total.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })
            }}
          </h2>
        </div>
      </div>

      <div class="alert-buttons-container">
        <button class="cancel-btn" @click="close()">
          Cancel
        </button>
        <button class="submit-btn" @click="submit()">
          Complete Payment
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReviewPaymentComponent',
  components: {},
  props: [
    "forPartialPayment",
    "invoice",
    "partialPaymentAmount",
    "useArta",
    "selectedShippingOption",
    'selectedPickUp',
    'total'
  ],
  computed: {
    convenienceFee: function () {
      let convenienceFee = ''

      if (this.invoice) {
        if (this.forPartialPayment) {
          convenienceFee = this.partialPaymentAmount * 3 / 100;
        } else {
          const convenienceItems = this.invoice.invoice_items.filter(item => item.convenience_fee === 'y')
          convenienceFee = convenienceItems.reduce((total, item) => total + parseFloat(item.total_charges), 0)
        }

        return `${convenienceFee.toFixed(2)}`
      }
    }
  },
  mounted() {
    if (this.forPartialPayment) {

    } else {

    }
  },
  methods: {
    /**
     * Gets called when user clicks OK button
     * @public
     */
    close: function () {
      this.$emit('close')
    },
    submit: function () {
      this.$emit('submit')
    }

  }
}
</script>

<style scoped>
.img-checkmark {
  width: 20px;
  height: 20px;
}

.total-container {
  min-width: 350px;
}

.alert-buttons-container {
  margin-top: 32px;
  display: flex;
  justify-content: space-between;
  width: 85%;
}

.cancel-btn {
  background-color: #ffffff;
  color: #333333;
  border-radius: 8px;
  margin: 0;
  margin-right: 40px;
  border: 1px solid rgba(51, 51, 51, 0.7);
  flex-basis: 50%;
}

.submit-btn {
  background-color: #007AFF;
  border-radius: 8px;
  color: #ffffff;
  border: none;
  flex-basis: 50%;
}
</style>
